import React from 'react';

const PrivacyPolicy = () => {
  return (
    <main className="bg-black min-h-screen py-12 px-6 sm:px-12 text-gray-200">
      <section className="max-w-4xl mx-auto bg-zinc-900 rounded-3xl p-8 shadow-lg">
        <h1 className="text-4xl font-extrabold text-purple-600 mb-6">Privacy Policy for LootLayer.ca</h1>
        <p className="text-sm text-gray-400 mb-8">Last updated: July 2025</p>

        <p className="mb-6">
          At <strong>LootLayer.ca</strong>, your privacy is very important to us. This Privacy Policy explains what information we collect, how we use it, and the choices you have regarding your information.
        </p>

        <h2 className="text-2xl font-semibold text-white mb-4">Information We Collect</h2>
        <p className="mb-4">
          When you use our website and purchase collectible items, we collect and store the following personal information:
        </p>
        <ul className="list-disc list-inside mb-6 space-y-1 text-gray-300">
          <li>Your <strong>username</strong></li>
          <li>Your <strong>email address</strong></li>
          <li>Your <strong>purchase history</strong> (records of your orders and transactions)</li>
        </ul>
        <p className="mb-8">
          We collect this information solely to provide you with a seamless shopping experience and to manage your account and orders.
        </p>

        <h2 className="text-2xl font-semibold text-white mb-4">How We Use Your Information</h2>
        <p className="mb-6">
          We use your information to:
        </p>
        <ul className="list-disc list-inside mb-8 space-y-1 text-gray-300">
          <li>Process and fulfill your orders</li>
          <li>Communicate with you regarding your purchases and account</li>
          <li>Improve our services and customer experience</li>
        </ul>
        <p className="mb-8">
          We do <strong>not</strong> use your information for any purposes other than those listed above.
        </p>

        <h2 className="text-2xl font-semibold text-white mb-4">Data Sharing and Selling</h2>
        <p className="mb-8">
          LootLayer.ca <strong>does not sell, trade, or rent your personal information</strong> to third parties. We do not share your data with advertisers or data brokers.
          Your information is only shared with trusted third parties when necessary to complete your purchase (e.g., payment processors, shipping companies) and only to the extent required to fulfill your orders.
        </p>

        <h2 className="text-2xl font-semibold text-white mb-4">Data Security</h2>
        <p className="mb-8">
          We take reasonable measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction.
        </p>

        <h2 className="text-2xl font-semibold text-white mb-4">Your Choices</h2>
        <p className="mb-8">
          You can:
        </p>
        <ul className="list-disc list-inside mb-8 space-y-1 text-gray-300">
          <li>Update or correct your account information by contacting us</li>
          <li>Request deletion of your personal data, subject to legal or business retention requirements</li>
        </ul>

        <h2 className="text-2xl font-semibold text-white mb-4">Cookies and Tracking</h2>
        <p className="mb-8">
          Our website may use cookies and similar technologies to enhance your experience, but we do not use them to collect personal data beyond what you provide.
        </p>

        <h2 className="text-2xl font-semibold text-white mb-4">Children’s Privacy</h2>
        <p className="mb-8">
          LootLayer.ca is not intended for children under the age of 13. We do not knowingly collect personal information from children.
        </p>

        <h2 className="text-2xl font-semibold text-white mb-4">Changes to This Policy</h2>
        <p className="mb-8">
          We may update this Privacy Policy occasionally. Changes will be posted on this page with an updated revision date.
        </p>

        <h2 className="text-2xl font-semibold text-white mb-4">Contact Us</h2>
        <p>
          If you have any questions or concerns about this Privacy Policy, please contact us at:
        </p>
        <ul className="list-none mt-2 space-y-1 text-gray-300">
          <li><strong>Email:</strong> <a href="mailto:support@lootlayer.ca" className="text-purple-500 hover:underline">support@lootlayer.ca</a></li>
        </ul>
      </section>
    </main>
  );
};

export default PrivacyPolicy;
